module.exports = __webpack_public_path__ + "static/img/5008_phase_function_Paper_Points.717bef2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/5008_phase_function_Paper_Points.png
// module id = ti77
// module chunks = 0